import React, { memo } from 'react';
import { ValidationErrors } from 'constants/validations';
import { Col, Form, FormModal, Input, Row, Select } from 'components';
import { useAddEdit } from './useAddEdit';

interface IAddEdit {
  openModal: boolean;
  onModalStateChange: () => void;
  dataToEdit?: any;
}

export const AddEditWarehouseModal = memo<IAddEdit>((props) => {
  const { openModal, dataToEdit, onModalStateChange } = props;
  const { form, handleSubmit, isLoadingUpdate, onCancel, states } = useAddEdit({
    dataToEdit,
    onModalStateChange,
  });

  return (
    <FormModal
      form={form}
      title={`${dataToEdit ? 'Update' : 'Add'} Warehouse`}
      okText={dataToEdit ? 'Save' : 'Add'}
      open={openModal}
      isLoading={isLoadingUpdate}
      onCancel={onCancel}
      onSubmit={handleSubmit}
    >
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Form.Item
            name="name"
            label="Warehouse Name*"
            rules={[
              {
                required: true,
                message: ValidationErrors.required('Warehouse Name'),
              },
            ]}
          >
            <Input size={'large'} />
          </Form.Item>
        </Col>
        {states && !!states?.length && (
          <Col span={12}>
            <Form.Item
              name="state"
              label="State*"
              rules={[
                {
                  required: true,
                  message: ValidationErrors.required('State'),
                },
              ]}
            >
              <Select size={'large'} options={states} />
            </Form.Item>
          </Col>
        )}
        <Col span={12}>
          <Form.Item
            name="city"
            label="City*"
            rules={[
              {
                required: true,
                message: ValidationErrors.required('City'),
              },
            ]}
          >
            <Input size={'large'} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="streetAddress"
            label="Street Address*"
            rules={[
              {
                required: true,
                message: ValidationErrors.required('Street Address'),
              },
            ]}
          >
            <Input size={'large'} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="zip"
            label="ZIP*"
            rules={[
              {
                required: true,
                message: ValidationErrors.required('ZIP'),
              },
            ]}
          >
            <Input size={'large'} />
          </Form.Item>
        </Col>
      </Row>
    </FormModal>
  );
});
